module.exports = __webpack_public_path__ + "static/scale-model-of-blackstone-valley-bike-path-in-worcester-massachusetts-33ab68a44906fc3441031bda8f6bb97a.png";